import { z } from 'zod';

import { campaignProgressPackSchema } from './campaign-catalogue-contract.ts';

const amount = z.number().int().nonnegative();
const inventory = z.object({ fiftyFifty: amount, freeze: amount, swapFrame: amount });
const resources = z.object({
  coins: amount,
  exp: amount,
  lives: amount,
  maxLives: amount.positive(),
  inventory,
  nextLifeAt: z.string().nullish(),
});
export const campaignPlayPackSchema = campaignProgressPackSchema;
export type CampaignPlayPack = z.infer<typeof campaignPlayPackSchema>;
const nextQuestion = z
  .object({ id: z.string().min(1) })
  .passthrough()
  .optional();
const campaignAnswerSchema = z.object({
  correct: z.boolean(),
  livesSpent: z.boolean().default(false),
  pack: campaignPlayPackSchema,
  packCompleted: z.boolean(),
  question: nextQuestion,
  resources,
  rewards: z.object({
    coins: amount.default(0),
    exp: amount.default(0),
    lives: amount.default(0),
    inventory: z
      .object({ fiftyFifty: amount.default(0), freeze: amount.default(0), swapFrame: amount.default(0) })
      .default({ fiftyFifty: 0, freeze: 0, swapFrame: 0 }),
  }),
});
const campaignStartSchema = z.object({
  campaignId: z.string().min(1),
  pack: campaignPlayPackSchema,
  question: nextQuestion,
});

export const parseCampaignAnswer = (value: unknown) => campaignAnswerSchema.parse(value);
export const parseCampaignStart = (value: unknown) => campaignStartSchema.parse(value);
export const parseCampaignHint = (value: unknown) =>
  z
    .object({
      hint: z.string(),
      removedOptionTitleIds: z.array(z.string()).optional(),
      screenshot: z.string().optional(),
      resources,
    })
    .parse(value);
